import React from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';
import { useBanners } from '../../components/BannerManager';
import { BACKEND_URL } from '../../Config/Const';
import { colores, fuentes } from '../../styles/variablesCss';

const PromosBancos = () => {
  const { banners } = useBanners();
  const fila3Banners = banners.fila3 || [];
  const validBanners = fila3Banners.filter(b => b && b.imagenWeb);

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Promociones Bancarias</Text>
      <View style={styles.grid}>
        {validBanners.map((banner) => {
          let imageUrl = banner.imagenWeb;
          if (imageUrl && !imageUrl.startsWith('http')) {
            imageUrl = BACKEND_URL + imageUrl;
          }
          return (
            <a
              key={banner.codBanner}
              href={banner.link || '#'}
              target={banner.link ? '_blank' : '_self'}
              rel="noopener noreferrer"
              style={styles.card}
              onClick={(e) => { if (!banner.link) e.preventDefault(); }}
            >
              <img
                src={imageUrl}
                alt={banner.titulo || 'Promo Banco'}
                style={styles.image}
              />
            </a>
          );
        })}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '90%',
    padding: 16,
  },
  title: {
    fontFamily: fuentes.bold,
    fontSize: 22,
    color: colores.textoPrincipal,
    marginBottom: 12,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: Platform.OS === 'web' ? 'repeat(auto-fill, minmax(260px, 1fr))' : '1fr',
    gap: 16,
  },
  card: {
    display: 'block',
    backgroundColor: '#fff',
    borderRadius: 8,
    overflow: 'hidden',
    ...(Platform.OS === 'web' ? { boxShadow: '0 2px 8px rgba(0,0,0,0.1)' } : {}),
  },
  image: {
    width: '90%',
    height: 'auto',
    display: 'block',
  },
});

export default PromosBancos;
